function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_903_183)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M57.1336 33.4197C56.4771 33.4197 55.94 32.8826 55.94 32.2261V25.0648H17.7465V32.2261C17.7465 32.8826 17.2094 33.4197 16.5529 33.4197C15.8965 33.4197 15.3594 32.8826 15.3594 32.2261V23.8713C15.3594 23.2148 15.8965 22.6777 16.5529 22.6777H57.1336C57.79 22.6777 58.3271 23.2148 58.3271 23.8713V32.2261C58.3271 32.8826 57.79 33.4197 57.1336 33.4197Z",
  fill: "url(#paint0_linear_903_183)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.4879 74.0002H8.1976C7.81566 74.0002 7.4576 73.8212 7.23082 73.5109C7.00405 73.2006 6.94437 72.8067 7.05179 72.4486L10.5011 61.4083C12.1602 56.0851 16.8031 52.0986 22.3173 51.2512L29.4905 50.1531C30.0992 50.0577 30.684 50.4396 30.8273 51.0483C30.875 51.1796 31.9253 54.9035 36.8428 54.9035C41.8199 54.9035 42.8344 51.0722 42.8463 51.0364C42.9895 50.4396 43.5744 50.0457 44.1831 50.1412L51.3563 51.2393C56.8705 52.0867 61.5134 56.0731 63.1724 61.3964L66.6218 72.4367C66.7411 72.7948 66.6695 73.1886 66.4428 73.499C66.2279 73.8212 65.8699 74.0002 65.4879 74.0002ZM9.82082 71.6131H63.8647L60.9047 62.1244C59.5082 57.6606 55.6292 54.3186 50.9982 53.6144L44.7799 52.6596C43.8489 54.6528 41.4379 57.2906 36.8428 57.2906C32.2476 57.2906 29.8366 54.6528 28.9057 52.6477L22.6873 53.6025C18.0682 54.3186 14.1773 57.6606 12.7808 62.1125L9.82082 71.6131Z",
  fill: "url(#paint1_linear_903_183)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.9394 74C18.8916 74 18.8439 74 18.7961 73.9881C18.1397 73.9045 17.6742 73.3077 17.7577 72.6513L18.9513 63.1029C18.9632 63.0193 18.9752 62.9477 18.999 62.8761L22.5797 52.1342C22.7826 51.5135 23.4629 51.1674 24.0836 51.3822C24.7042 51.5851 25.0503 52.2655 24.8355 52.8861L21.2906 63.5206L20.109 72.9497C20.0494 73.5584 19.5361 74 18.9394 74Z",
  fill: "url(#paint2_linear_903_183)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.94 74.0003C55.3432 74.0003 54.83 73.5587 54.7584 72.95L53.5768 63.5209L50.032 52.8864C49.8291 52.2658 50.1632 51.5854 50.7839 51.3825C51.4165 51.1796 52.0849 51.5138 52.2878 52.1345L55.8684 62.8764C55.8923 62.948 55.9162 63.0316 55.9162 63.1032L57.1097 72.6516C57.1932 73.308 56.7278 73.9048 56.0713 73.9884C56.0355 74.0003 55.9878 74.0003 55.94 74.0003Z",
  fill: "url(#paint3_linear_903_183)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.6818 52.5164C29.0254 52.5164 28.4883 51.9793 28.4883 51.3228V48.9357C28.4883 48.2793 29.0254 47.7422 29.6818 47.7422C30.3383 47.7422 30.8754 48.2793 30.8754 48.9357V51.3228C30.8754 51.9793 30.3383 52.5164 29.6818 52.5164Z",
  fill: "url(#paint4_linear_903_183)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.0041 52.5164C43.3476 52.5164 42.8105 51.9793 42.8105 51.3228V48.9357C42.8105 48.2793 43.3476 47.7422 44.0041 47.7422C44.6605 47.7422 45.1976 48.2793 45.1976 48.9357V51.3228C45.1976 51.9793 44.6605 52.5164 44.0041 52.5164Z",
  fill: "url(#paint5_linear_903_183)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.8425 51.3229C27.6283 51.3229 20.1328 43.8274 20.1328 34.6132V23.8713C20.1328 23.2148 20.6699 22.6777 21.3264 22.6777C21.9828 22.6777 22.5199 23.2148 22.5199 23.8713V34.6132C22.5199 42.5145 28.9412 48.9358 36.8425 48.9358C44.7438 48.9358 51.1651 42.5145 51.1651 34.6132V23.8713C51.1651 23.2148 51.7022 22.6777 52.3586 22.6777C53.0151 22.6777 53.5522 23.2148 53.5522 23.8713V34.6132C53.5522 43.8274 46.0567 51.3229 36.8425 51.3229Z",
  fill: "url(#paint6_linear_903_183)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.3576 38.1933C51.7012 38.1933 51.1641 37.6562 51.1641 36.9997C51.1641 36.3433 51.7012 35.8062 52.3576 35.8062C54.327 35.8062 55.9383 34.1949 55.9383 32.2256C55.9383 30.2562 54.327 28.6449 52.3576 28.6449C51.7012 28.6449 51.1641 28.1078 51.1641 27.4514C51.1641 26.7949 51.7012 26.2578 52.3576 26.2578C55.6518 26.2578 58.3254 28.9314 58.3254 32.2256C58.3254 35.5197 55.6518 38.1933 52.3576 38.1933Z",
  fill: "url(#paint7_linear_903_183)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.3271 38.1933C18.0329 38.1933 15.3594 35.5197 15.3594 32.2256C15.3594 28.9314 18.0329 26.2578 21.3271 26.2578C21.9836 26.2578 22.5207 26.7949 22.5207 27.4514C22.5207 28.1078 21.9836 28.6449 21.3271 28.6449C19.3578 28.6449 17.7465 30.2562 17.7465 32.2256C17.7465 34.1949 19.3578 35.8062 21.3271 35.8062C21.9836 35.8062 22.5207 36.3433 22.5207 36.9997C22.5207 37.6562 21.9836 38.1933 21.3271 38.1933Z",
  fill: "url(#paint8_linear_903_183)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.8102 34.6132H30.8747C24.9547 34.6132 20.1328 29.7913 20.1328 23.8713C20.1328 23.2148 20.6699 22.6777 21.3264 22.6777C21.9828 22.6777 22.5199 23.2148 22.5199 23.8713C22.5199 28.4784 26.2677 32.2261 30.8747 32.2261H42.8102C47.4173 32.2261 51.1651 28.4784 51.1651 23.8713C51.1651 23.2148 51.7022 22.6777 52.3586 22.6777C53.0151 22.6777 53.5522 23.2148 53.5522 23.8713C53.5522 29.7913 48.7302 34.6132 42.8102 34.6132Z",
  fill: "url(#paint9_linear_903_183)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.1336 25.0649C56.4771 25.0649 55.94 24.5278 55.94 23.8714C55.94 14.0007 47.9074 5.96815 38.0368 5.96815H35.6497C25.7791 5.96815 17.7465 14.0007 17.7465 23.8714C17.7465 24.5278 17.2094 25.0649 16.5529 25.0649C15.8965 25.0649 15.3594 24.5278 15.3594 23.8714C15.3594 12.6878 24.4661 3.58105 35.6497 3.58105H38.0368C49.2203 3.58105 58.3271 12.6878 58.3271 23.8714C58.3271 24.5278 57.79 25.0649 57.1336 25.0649Z",
  fill: "url(#paint10_linear_903_183)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.4232 5.96774C39.7667 5.96774 39.2297 5.43065 39.2297 4.77419C39.2297 3.46129 38.1555 2.3871 36.8426 2.3871C35.5296 2.3871 34.4555 3.46129 34.4555 4.77419C34.4555 5.43065 33.9184 5.96774 33.2619 5.96774C32.6055 5.96774 32.0684 5.43065 32.0684 4.77419C32.0684 2.13645 34.2048 0 36.8426 0C39.4803 0 41.6167 2.13645 41.6167 4.77419C41.6167 5.43065 41.0797 5.96774 40.4232 5.96774Z",
  fill: "url(#paint11_linear_903_183)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.4865 25.0642C27.8301 25.0642 27.293 24.5271 27.293 23.8706V23.3932C27.293 16.4229 29.4294 9.75096 33.4875 4.0816C33.8694 3.54451 34.6214 3.42515 35.1465 3.80709C35.6836 4.18902 35.803 4.94096 35.421 5.46612C31.6733 10.7297 29.6801 16.9242 29.6801 23.3932V23.8706C29.6801 24.5271 29.143 25.0642 28.4865 25.0642Z",
  fill: "url(#paint12_linear_903_183)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.1964 25.0641C44.54 25.0641 44.0029 24.527 44.0029 23.8705V23.3931C44.0029 22.7725 43.991 22.1638 43.9432 21.5551C43.9074 20.8986 44.4087 20.3257 45.0651 20.2899C45.7216 20.266 46.2945 20.7554 46.3303 21.4118C46.3661 22.0683 46.39 22.7367 46.39 23.3931V23.8705C46.39 24.527 45.8529 25.0641 45.1964 25.0641Z",
  fill: "url(#paint13_linear_903_183)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.4927 17.9029C43.9437 17.9029 43.4424 17.521 43.323 16.96C42.4279 12.7945 40.733 8.92741 38.2504 5.46612C37.8685 4.92902 37.9879 4.18902 38.525 3.80709C39.0621 3.42515 39.8021 3.54451 40.184 4.0816C42.8456 7.80547 44.6837 11.971 45.6385 16.4587C45.7817 17.1032 45.364 17.7358 44.7195 17.879C44.6598 17.891 44.5763 17.9029 44.4927 17.9029Z",
  fill: "url(#paint14_linear_903_183)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.4568 73.9996C33.8003 73.9996 33.2632 73.4625 33.2632 72.806V69.2254C33.2632 68.9031 33.3945 68.6047 33.6094 68.3779L35.6503 66.3489V62.7086L34.4568 61.9089V64.4512C34.4568 65.1076 33.9197 65.6447 33.2632 65.6447H28.489C27.8326 65.6447 27.2955 65.1076 27.2955 64.4512V61.9089L26.1019 62.7086V66.3489L28.1429 68.3899C28.3577 68.6047 28.489 68.9031 28.489 69.2254V72.806C28.489 73.4625 27.9519 73.9996 27.2955 73.9996C26.639 73.9996 26.1019 73.4625 26.1019 72.806V69.7147L24.061 67.6738C23.8461 67.4589 23.7148 67.1605 23.7148 66.8383V62.0641C23.7148 61.6702 23.9177 61.2883 24.2519 61.0734L27.8326 58.6863C28.2026 58.4357 28.6681 58.4238 29.0619 58.6267C29.4439 58.8296 29.6826 59.2354 29.6826 59.677V63.2576H32.0697V59.677C32.0697 59.2354 32.3084 58.8296 32.7023 58.6267C33.0842 58.4238 33.5616 58.4357 33.9316 58.6863L37.5123 61.0734C37.8345 61.2883 38.0374 61.6702 38.0374 62.0641V66.8383C38.0374 67.1605 37.9061 67.4589 37.6913 67.6857L35.6503 69.7147V72.806C35.6503 73.4625 35.1132 73.9996 34.4568 73.9996Z",
  fill: "url(#paint15_linear_903_183)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.5851 73.9999C46.9287 73.9999 46.3916 73.4628 46.3916 72.8064V66.8386C46.3916 66.5164 46.5229 66.218 46.7377 65.9912L47.5851 65.1557V63.4967L45.58 58.4838H44.8042L42.8109 63.4847V65.1438L43.6583 65.9912C43.8732 66.218 44.0045 66.5164 44.0045 66.8386V72.8064C44.0045 73.4628 43.4674 73.9999 42.8109 73.9999C42.1545 73.9999 41.6174 73.4628 41.6174 72.8064V67.328L40.77 66.4806C40.5551 66.2657 40.4238 65.9673 40.4238 65.6451V63.258C40.4238 63.1028 40.4477 62.9596 40.5074 62.8164L42.8945 56.8486C43.0735 56.3951 43.5151 56.0967 44.0045 56.0967H46.3916C46.8809 56.0967 47.3225 56.3951 47.5016 56.8486L49.8887 62.8164C49.9483 62.9596 49.9722 63.1028 49.9722 63.258V65.6451C49.9722 65.9673 49.8409 66.2657 49.6261 66.4925L48.7787 67.328V72.8064C48.7787 73.4628 48.2416 73.9999 47.5851 73.9999Z",
  fill: "url(#paint16_linear_903_183)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_903_183",
  x1: 36.8432,
  y1: 22.6777,
  x2: 36.8432,
  y2: 33.4197,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C60606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#550707"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_903_183",
  x1: 36.8394,
  y1: 50.127,
  x2: 36.8394,
  y2: 74.0002,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C60606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#550707"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_903_183",
  x1: 21.3237,
  y1: 51.3184,
  x2: 21.3237,
  y2: 74,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C60606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#550707"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_903_183",
  x1: 53.546,
  y1: 51.3232,
  x2: 53.546,
  y2: 74.0003,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C60606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#550707"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_903_183",
  x1: 29.6818,
  y1: 47.7422,
  x2: 29.6818,
  y2: 52.5164,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C60606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#550707"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_903_183",
  x1: 44.0041,
  y1: 47.7422,
  x2: 44.0041,
  y2: 52.5164,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C60606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#550707"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_903_183",
  x1: 36.8425,
  y1: 22.6777,
  x2: 36.8425,
  y2: 51.3229,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C60606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#550707"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_903_183",
  x1: 54.7447,
  y1: 26.2578,
  x2: 54.7447,
  y2: 38.1933,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C60606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#550707"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_903_183",
  x1: 18.94,
  y1: 26.2578,
  x2: 18.94,
  y2: 38.1933,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C60606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#550707"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_903_183",
  x1: 36.8425,
  y1: 22.6777,
  x2: 36.8425,
  y2: 34.6132,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C60606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#550707"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_903_183",
  x1: 36.8432,
  y1: 3.58105,
  x2: 36.8432,
  y2: 25.0649,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C60606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#550707"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_903_183",
  x1: 36.8426,
  y1: 0,
  x2: 36.8426,
  y2: 5.96774,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C60606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#550707"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_903_183",
  x1: 31.4686,
  y1: 3.58398,
  x2: 31.4686,
  y2: 25.0642,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C60606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#550707"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear_903_183",
  x1: 45.1657,
  y1: 20.2891,
  x2: 45.1657,
  y2: 25.0641,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C60606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#550707"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_903_183",
  x1: 41.847,
  y1: 3.58398,
  x2: 41.847,
  y2: 17.9029,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C60606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#550707"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_903_183",
  x1: 30.8761,
  y1: 58.4854,
  x2: 30.8761,
  y2: 73.9996,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C60606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#550707"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear_903_183",
  x1: 45.198,
  y1: 56.0967,
  x2: 45.198,
  y2: 73.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C60606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#550707"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_903_183"
}, /*#__PURE__*/React.createElement("rect", {
  width: 74,
  height: 74,
  fill: "white"
})));

function SvgMechanic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMechanic);
export default __webpack_public_path__ + "static/media/mechanic.ca4e779f.svg";
export { ForwardRef as ReactComponent };